// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"20":"26182787","228":"f06b0f6f","332":"f06b0f6f","634":"f06b0f6f"}[chunkId] + ".chunk.css";
};